import React, { useEffect, useState } from "react";
import { CardBody, Row, Col } from "reactstrap";
import { CardStyled } from "./styles";

export default function CardInactiveRestaurants({ restaurant }) {
  const image = restaurant.avatar ? restaurant.avatar.url : "";

  const newestSession = restaurant.last_session_date
    ? new Date(restaurant.last_session_date)
    : new Date(restaurant.created_at);

  const [diffDays, setDiffDays] = useState("");

  useEffect(() => {
    const today = new Date();
    const date = newestSession;
    const diffTime = Math.abs(today - date);
    setDiffDays(Math.ceil(diffTime / (1000 * 60 * 60 * 24)));
  }, [newestSession, restaurant.createdAt]);

  return (
    <>
      <CardStyled>
        <CardBody>
          <Row>
            <Col md="3" style={{ margin: "auto" }}>
              {image !== "" ? <img alt="..." src={image} /> : <p>Sem foto</p>}
            </Col>
            <Col md="9">
              <h6>{restaurant.fantasy_name}</h6>
              <span>{restaurant.name}</span>
              <p>{restaurant.email}</p>

              <p>Dias sem comandas: {diffDays}</p>
              <p>Comandass: {restaurant.sessions_count}</p>
              <p>
                Última comanda:{" "}
                {newestSession.toLocaleDateString("pt-BR", { timeZone: "UTC" })}
              </p>
            </Col>
          </Row>

          <hr />
        </CardBody>
      </CardStyled>
    </>
  );
}
